export const overall = "Overall";
export const collection_userrecords_proxy = "kanha-volunteering";
export const collection_admin = `AOKanhaVolunteeringAdmin`;
